import { EVENT_NAME_MAX_LENGTH } from '~/utils/EVENT_NAME_MAX_LENGTH'
import { Normalization } from '~/utils/normalization'

/** Trims the name and caps it at EVENT_NAME_MAX_LENGTH characters; blank is null. */
export function normalizeEventName(raw: unknown): string | null {
  const name = Normalization.trimmedStringValue(raw, null)
  return name === null ? null : Array.from(name).slice(0, EVENT_NAME_MAX_LENGTH).join('')
}
